/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import classes from './ArrowLeftButton.scss';

interface IArrowLeftButton {
  clicked: () => void;
  fill?: string;
}

const ArrowLeftButton: React.FC<IArrowLeftButton> = ({ clicked }) => (
  <>
    <div
      className={classes.arrowLeftButton}
      role="button"
      tabIndex={0}
      onClick={(event) => {
        event.stopPropagation();
        clicked();
      }}
      onKeyDown={() => {}}
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 18L9 12L15 6" stroke="#0B1215" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  </>
);

export default ArrowLeftButton;
